export default __webpack_public_path__ + "static/media/sbidu.53d11c4e.jpg";